import type { KinVar } from "@/lib/tool-kit/physics-mechanics/kinematics";
import {
  ACCELERATION,
  LENGTH,
  SPEED,
  TIME,
  type UnitFamily,
} from "@/lib/tool-kit/physics-mechanics/units";

/** Which unit family each SUVAT variable is measured in. */
export const KIN_FAMILIES: Record<KinVar, UnitFamily> = {
  s: LENGTH,
  u: SPEED,
  v: SPEED,
  a: ACCELERATION,
  t: TIME,
};

/** The unit each variable starts in. */
export const KIN_DEFAULT_UNITS: Record<KinVar, string> = {
  s: "m",
  u: "mps",
  v: "mps",
  a: "mps2",
  t: "s",
};
